import React from 'react';
import FaqList from './FaqList';

import classnames from 'classnames/bind';
import styles from './faq.module.scss';
const cx = classnames.bind(styles);

interface FAQProps {
  fadeIn: boolean;
}

const FAQ = ({ fadeIn }: FAQProps) => {
  return (
    <div className={cx('sectionInner', 'faqArea', { on: fadeIn })}>
      <span className={cx('mainTitle')}>역검, 이런 부분은 더 궁금해요!</span>
      <div className={cx('faqInner', { on: fadeIn })}>
        <FaqList />
      </div>
    </div>
  );
};

export default FAQ;
